import { render, staticRenderFns } from "./GotQuestions.vue?vue&type=template&id=61cc71c9&"
import script from "./GotQuestions.vue?vue&type=script&lang=js&"
export * from "./GotQuestions.vue?vue&type=script&lang=js&"
import style0 from "./GotQuestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports